import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/scss/dist.scss';
import Index from './pages/Index';
// import Cursor from "./component/Cursor/Cursor";
// import {device, matchedMedia} from "./utils/CheckDevice";
// import Loading from "./component/Loading";
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
      <main className="w-screen" style={{width: '100%', maxWidth: '100vw'}}>
        {/*<Suspense fallback={<Loading/>}>*/}
        <Index/>
        {/*</Suspense>*/}
      </main>
      {/*{(device() === 'desktop' && matchedMedia()) && <Cursor/>}*/}
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
